import React, { useState } from "react";
import Chicken from "../assets/images/chicken.png";
import iconPlusW from "../assets/images/Icon-plus-w.svg";
import iconChevronDown from "../assets/images/icon-chevron-down.svg";
import iconChevronUp from "../assets/images/icon-chevron-up.svg";
import "./CardClosed.css";

const DEFAULT_SIDE_OPTIONS = [
  "Riz « frit » et légumes du marché",
  "Patates douces et légumes",
  "Légumes seulements ( +0,95 $ )",
];

const DEFAULT_SIZE_OPTIONS = ["Régulier", "Familial", "Petit"];

function newSelection(sideOptions, sizeOptions) {
  return { side: sideOptions[0], size: sizeOptions[0] };
}

export default function CardClosed({
  image = Chicken,
  title = "Hauts de cuisse de poulet grillés miel et ail",
  tags = [
    { label: "Grillé", variant: "default" },
    { label: "Protéines", variant: "default" },
    { label: "Format familial", variant: "highlight" },
  ],
  initialQuantity = 1,
  sideOptions = DEFAULT_SIDE_OPTIONS,
  sizeOptions: customSizeOptions,
  onAdd,
  onInfoClick,
}) {
  const [quantity, setQuantity] = useState(initialQuantity);

  const hasFamilyTag =
    tags && tags.some((tag) => tag.label === "Format familial");

  const sizeOptions =
    customSizeOptions ||
    (hasFamilyTag
      ? DEFAULT_SIZE_OPTIONS
      : DEFAULT_SIZE_OPTIONS.filter((size) => size !== "Familial"));

  // One selection object per meal: { side, size }
  const [selections, setSelections] = useState(
    Array.from({ length: initialQuantity }, () =>
      newSelection(sideOptions, sizeOptions),
    ),
  );

  // Which dropdown is open: { row: number, type: 'side' | 'size' } | null
  const [openDropdown, setOpenDropdown] = useState(null);

  const isOpen = (row, type) =>
    openDropdown && openDropdown.row === row && openDropdown.type === type;

  const toggleDropdown = (row, type) => {
    setOpenDropdown((prev) =>
      prev && prev.row === row && prev.type === type ? null : { row, type },
    );
  };

  const pickOption = (row, type, value) => {
    setSelections((prev) =>
      prev.map((sel, i) => (i === row ? { ...sel, [type]: value } : sel)),
    );
    setOpenDropdown(null);
  };

  const handleIncrement = () => {
    setQuantity((q) => q + 1);
    setSelections((prev) => [...prev, newSelection(sideOptions, sizeOptions)]);
  };
  return (
    <div className="card-closed">
      <div className="card-children">
        <div
          className="card-image"
          onClick={onInfoClick}
          style={onInfoClick ? { cursor: "pointer" } : {}}
        >
          <img src={image} alt={title} />
        </div>
        <div className="card-content">
          <div className="card-rows">
            <p className="card-title">{title}</p>
            <div className="card-prices">
              <span>14,95 $</span>
            </div>
          </div>

          <div className="card-tags">
            {tags.map((tag, i) => (
              <span
                key={i}
                className={`card-tag${tag.variant === "highlight" ? " card-tag--highlight" : ""}`}
              >
                {tag.label}
              </span>
            ))}
          </div>
        </div>
      </div>
      <button className="card-add" onClick={onAdd}>
        <span>Ajouter</span>
        <img src={iconPlusW} alt="" className="card-add-icon" />
      </button>
    </div>
  );
}
